import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/sign-up-login-screen/components/AuthClient.tsx");
